"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../assets/constants/constants");
const format_1 = require("../../utils/format");
class Checkout {
    constructor(payment, guest) {
        this.payment = payment;
        this.guest = guest;
    }
    CreditPayload({ card }, confirmValues) {
        var _a, _b;
        const { suites } = this.guest;
        const phoneCard = this.payment.phone.replace(constants_1.PHONE_REGEX, '').split(' ');
        const DDD = phoneCard[0].substr(0, 2).trim();
        const phone = phoneCard[1].slice(2).trim();
        const suite = suites[0];
        const paymentDoc = this.payment.cardDocument.replace(constants_1.PERSONAL_DOC_REGEX, '');
        const data = (0, moment_1.default)(this.payment.birthday.toString(), 'DD/MM/YYYY');
        const birhDateFormat = data.format('YYYY-MM-DD');
        const rawPostalCode = suite.addressCep.replace(constants_1.CEP_HYPHEN_REGEX, '');
        const description = confirmValues.suite.suiteTitle +
            (Number(confirmValues.dailyQtyString) > 1 ? ` / Total de Diarias: ${confirmValues.dailyQtyString}` : '');
        const Payload = {
            billing: {
                street: suite.addressName.trim(),
                number: suite.addressNumber,
                complement: (_a = suite.addressComplement) === null || _a === void 0 ? void 0 : _a.trim(),
                district: suite.addressDistrict.trim(),
                city: suite.addressCity.trim(),
                state: suite.addressState.trim(),
                country: 'BRA',
                postalCode: rawPostalCode.trim(),
                useShippingAddress: false,
            },
            creditCard: {
                token: card.token,
                holder: {
                    birthDate: birhDateFormat,
                    name: this.payment.cardName.trim(),
                    document: {
                        type: 'CPF',
                        value: paymentDoc,
                    },
                    phone: {
                        areaCode: DDD,
                        number: phone,
                    },
                },
                installment: this.payment.installmentObject,
            },
            items: [
                {
                    id: confirmValues.suite.roomId,
                    description,
                    amount: (0, format_1.strValuePtBrToNumber)(confirmValues.suitePrice),
                    quantity: 1,
                    shippingCost: 0,
                    weight: 0,
                },
            ],
            sender: {
                name: suite.fullnameRequired.trim(),
                email: this.guest.email.trim(),
                hash: this.payment.senderHash,
                phone: {
                    areaCode: DDD,
                    number: phone,
                },
                document: {
                    type: 'CPF',
                    value: paymentDoc,
                },
            },
            extraAmount: Number(confirmValues.suite.cleaningFee),
            method: this.payment.paymentType,
            reference: confirmValues.bookId,
            couponPhrase: ((_b = confirmValues.coupon) === null || _b === void 0 ? void 0 : _b.phrase) || undefined,
            refundProtect: !!confirmValues.refundPrice,
            refundPrice: Number((0, format_1.getFormattedDouble)(confirmValues.refundPrice).replace('.', '').replace(',', '.')) || 0,
            refundEndDateTime: (0, moment_1.default)(confirmValues.finalDate).toISOString(),
            totalPrice: Number((0, format_1.getFormattedDouble)(confirmValues.totalPrice).replace('.', '').replace(',', '.')),
        };
        return Payload;
    }
    DebitPayload(confirmValues) {
        var _a, _b, _c;
        const { suites } = this.guest;
        const suite = suites[0];
        const phoneRequired = this.payment.phoneBR || suite.phoneRequired;
        const phoneCard = phoneRequired.toString().replace(constants_1.PHONE_REGEX, '');
        const DDD = phoneCard.substr(0, 2).trim();
        const phone = phoneCard.slice(2).trim();
        const paymentDocCPF = this.payment.paymentDocCPF || suite.documentGuestRequired;
        const paymentDoc = paymentDocCPF.replace(constants_1.PERSONAL_DOC_REGEX, '');
        const rawPostalCode = suite.addressCep.replace(constants_1.CEP_HYPHEN_REGEX, '');
        const description = confirmValues.suite.suiteTitle +
            (Number(confirmValues.dailyQtyString) > 1 ? ` / Total de Diarias: ${confirmValues.dailyQtyString}` : '');
        const Payload = {
            shipping: {
                type: 3,
                cost: 0,
                street: suite.addressName.trim(),
                number: suite.addressNumber,
                complement: (_a = suite.addressComplement) === null || _a === void 0 ? void 0 : _a.trim(),
                district: suite.addressDistrict.trim(),
                city: suite.addressCity.trim(),
                state: suite.addressState.trim(),
                country: 'BRA',
                postalCode: rawPostalCode.trim(),
            },
            bank: {
                name: (_b = this.payment.bank) === null || _b === void 0 ? void 0 : _b.trim(),
            },
            items: [
                {
                    id: confirmValues.suite.roomId,
                    description,
                    amount: (0, format_1.strValuePtBrToNumber)(confirmValues.suitePrice),
                    quantity: 1,
                    shippingCost: 0,
                    weight: 0,
                },
            ],
            sender: {
                name: suite.fullnameRequired.trim(),
                email: this.guest.email.trim(),
                hash: this.payment.senderHash,
                phone: {
                    areaCode: DDD,
                    number: phone,
                },
                document: {
                    type: 'CPF',
                    value: paymentDoc,
                },
            },
            extraAmount: Number(confirmValues.suite.cleaningFee),
            method: this.payment.paymentType,
            reference: confirmValues.bookId,
            couponPhrase: ((_c = confirmValues.coupon) === null || _c === void 0 ? void 0 : _c.phrase) || undefined,
            refundProtect: !!confirmValues.refundPrice,
            refundPrice: Number((0, format_1.getFormattedDouble)(confirmValues.refundPrice).replace('.', '').replace(',', '.')) || 0,
            refundEndDateTime: (0, moment_1.default)(confirmValues.finalDate).toISOString(),
            totalPrice: Number((0, format_1.getFormattedDouble)(confirmValues.totalPrice).replace('.', '').replace(',', '.')),
        };
        return Payload;
    }
    PixPayload(confirmValues) {
        var _a, _b;
        const { suites } = this.guest;
        const suite = suites[0];
        const phoneRequired = this.payment.phoneBR || suite.phoneRequired;
        const phoneCard = phoneRequired.toString().replace(constants_1.PHONE_REGEX, '');
        const DDD = phoneCard.substr(0, 2).trim();
        const phone = phoneCard.slice(2).trim();
        const paymentDocCPF = this.payment.paymentDocCPF || suite.documentGuestRequired;
        const paymentDoc = paymentDocCPF.replace(constants_1.PERSONAL_DOC_REGEX, '');
        const rawPostalCode = suite.addressCep.replace(constants_1.CEP_HYPHEN_REGEX, '');
        const description = confirmValues.suite.suiteTitle +
            (Number(confirmValues.dailyQtyString) > 1 ? ` / Total de Diarias: ${confirmValues.dailyQtyString}` : '');
        const Payload = {
            shipping: {
                type: 3,
                cost: 0,
                street: suite.addressName.trim(),
                number: suite.addressNumber,
                complement: (_a = suite.addressComplement) === null || _a === void 0 ? void 0 : _a.trim(),
                district: suite.addressDistrict.trim(),
                city: suite.addressCity.trim(),
                state: suite.addressState.trim(),
                country: 'BRA',
                postalCode: rawPostalCode.trim(),
            },
            items: [
                {
                    id: confirmValues.suite.roomId,
                    description,
                    amount: (0, format_1.strValuePtBrToNumber)(confirmValues.suitePrice),
                    quantity: 1,
                    shippingCost: 0,
                    weight: 0,
                },
            ],
            sender: {
                name: suite.fullnameRequired.trim(),
                email: this.guest.email.trim(),
                hash: this.payment.senderHash,
                phone: {
                    areaCode: DDD,
                    number: phone,
                },
                document: {
                    type: 'CPF',
                    value: paymentDoc,
                },
            },
            extraAmount: Number(confirmValues.suite.cleaningFee),
            method: this.payment.paymentType,
            reference: confirmValues.bookId,
            couponPhrase: ((_b = confirmValues.coupon) === null || _b === void 0 ? void 0 : _b.phrase) || undefined,
            refundProtect: !!confirmValues.refundPrice,
            refundPrice: Number((0, format_1.getFormattedDouble)(confirmValues.refundPrice).replace('.', '').replace(',', '.')) || 0,
            refundEndDateTime: (0, moment_1.default)(confirmValues.finalDate).toISOString(),
            totalPrice: Number((0, format_1.getFormattedDouble)(confirmValues.totalPrice).replace('.', '').replace(',', '.')),
        };
        return Payload;
    }
}
exports.Checkout = Checkout;
